import React from 'react';

import styles from './BookTurnButton.scss';
import PageTurnIcon from './page-turn-arrow.svg';

const BookTurnButton = ({ direction, onPageTurn, allow }) => {
  const clickHandler = allow ? onPageTurn : null;
  return (
    <button
      type="button"
      className={`BookTurnButton ${allow ? '' : 'is-disabled'}`}
      onClick={clickHandler}
      data-direction={direction}
      title={`${direction} page`}
      disabled={!allow}
    >
      <PageTurnIcon className="BookTurnButton__icon" />
      <span className="BookTurnButton__label">{direction}</span>
    </button>
  );
};

export default BookTurnButton;
